export default {
    "loading": "載入中",
    "notLong": "這應該不會花很長時間!",
    "wait": "請耐心等待",
    "providedBy": "提供的資訊安全意識",
    "exit": "離開",
    "replay": "重播",
    "completedTutorial": "您完成了這個課程",
    "congrats": "恭喜!",
    "soundOn": "請確定已開啟您的喇叭",
    "start": "開始",
    "confirm": "提交",
    "correct": "正確",
    "incorrect": "不正確",
    "ok": "繼續",
    "cancel": "取消",
    "explanation": "說明",
    "questionResults": "結果",
    "thankyou": "感謝您的時間",
    "approvalInfo": "作为反馈团队的成员，我们需要您的批准才能将其发布给您组织的其他成员！",
    "iapprove": "我授權本教程",
    "enterComments": "在此輸入任何評論",
    "sendExit": "發送和退出"
}